<template>
  <div class="forgot-password-wrapper"></div>
</template>

<script setup lang="ts">
import { type Modal } from "@/assets/js/types";
import { ModalStore } from "../../../store/modalStore";
const modalStore = ModalStore();

function setModal() {
  modalStore.setModalData(null);
  setTimeout(() => {
    const params: Modal = {
      title: "Forgot password",
      component: "forgotPasswordModal",
      options: {
        hideBackdrop: true,
        hideClose: true,
        transparentModal: true,
      },
    };
    modalStore.setModalData(params);
  }, 100);
}

onMounted(() => {
  console.log("onMounted");
  setModal();
});

onBeforeUnmount(() => {
  modalStore.setModalData(null);
});
</script>

<style lang="scss" scoped>
.login-wrapper {
  padding-top: var(--vt-c-header-height);
}
</style>
